export enum DiagnosisActionsEnum {
  SET_RATING = '@diagnosis/SET_RATING',
  SET_STEP = '@diagnosis/SET_STEP',
  SET_GENDER = '@diagnosis/SET_GENDER',
  SET_AGE = '@diagnosis/SET_AGE',
  SET_SYMPTOMS = '@diagnosis/SET_SYMPTOMS',
  SET_RESULTS = '@diagnosis/SET_RESULTS',
  SET_CLOSE_TASTING_BANNER = '@diagnosis/SET_CLOSE_TASTING_BANNER',
}
